import React from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router';

import { config } from '~shared/config';
import { SILENT_ERROR_MESSAGE_PATTERN } from '~shared/lib/create-silent-error';

import * as Sentry from '@breeze/web-lib-sentry';
import { findOrCreateWuid } from '@breeze/web-lib-wuid';
import Clarity from '@microsoft/clarity';

const wuid = findOrCreateWuid();

Sentry.initSentry({
  dsn: import.meta.env.VITE_SENTRY_HOST,
  release: config.version,
  environment: config.environment,
  ignoreErrors: [SILENT_ERROR_MESSAGE_PATTERN],
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration({
      // networkDetailAllowUrls: [import.meta.env.VITE_API_HOST],
      // networkResponseHeaders: ['Server'],
    }),
  ],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
Sentry.setUser({ id: wuid });

Clarity.init(config.clarityKey);
Clarity.identify(wuid);
Clarity.setTag('wuid', wuid);
